import API from "..";

export interface Supplier {
  supplierName: string;
  description: string;
  supplierLocation: string;
  certificationDate: string | null;
  certifiedByEmail: string;
  createdByEmail: string;
  createdDate: string;
  lastModifiedByEmail: string | null;
  lastModifiedDate: string | null;
  tradenames: unknown[];
}

export interface SupplierPayload {
  supplierName: string;
  description: string;
  supplierLocation: string;
  certificationDate: string | null;
  certifiedByEmail: string;
}

export default class SupplierApi {
  static async getAll(signal?: AbortSignal): Promise<Supplier[]> {
    const api = await API();
    if (!api) return [];
    const { data } = await api.get(`/supplier`, signal ? { signal } : undefined);
    return data.result as Supplier[];
  }

  static async getBySupplierName(supplierName: string): Promise<Supplier | null> {
    const api = await API();
    if (!api) return null;
    const { data } = await api.get(`/supplier?supplierName=${encodeURIComponent(supplierName)}`);
    return data.result ? (data.result as Supplier) : null;
  }

  static async update(payload: SupplierPayload): Promise<unknown> {
    const api = await API();
    if (!api) return;
    const { data } = await api.put(`/supplier`, payload);
    return data;
  }

  static async create(payload: SupplierPayload): Promise<unknown> {
    const api = await API();
    if (!api) return;
    const { data } = await api.post(`/supplier`, payload);
    return data;
  }

  static async delete(supplierName: string): Promise<unknown> {
    const api = await API();
    if (!api) return;
    const { data } = await api.delete(`/supplier/${encodeURIComponent(supplierName)}`);
    return data;
  }
}
